import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { subscribeGlobalError } from '../utils/functions/globalError';

// แสดง dialog แจ้ง error ให้ user เห็นทุกครั้งที่ API ตอบ error หรือมี promise rejection
// ที่ไม่ถูก catch ที่ไหนเลย — mount ครั้งเดียวที่ root (index.js) ครอบคลุมทั้งแอป
const GlobalErrorDialog = () => {
  const [message, setMessage] = useState(null);

  useEffect(() => subscribeGlobalError((msg) => setMessage(msg)), []);

  useEffect(() => {
    const handleRejection = (event) => {
      // axios interceptor (utils/functions/api.js) แจ้ง dialog ไปแล้ว — กันไม่ให้เด้งซ้ำ
      if (event.reason?.__globalErrorHandled) {
        event.preventDefault();
        return;
      }
      const reason = event.reason;
      const msg =
        reason?.response?.data?.message ||
        reason?.message ||
        (typeof reason === 'string' ? reason : null) ||
        'เกิดข้อผิดพลาดที่ไม่คาดคิด';
      setMessage(msg);
      event.preventDefault();
    };
    window.addEventListener('unhandledrejection', handleRejection);
    return () =>
      window.removeEventListener('unhandledrejection', handleRejection);
  }, []);

  return (
    <Dialog
      open={!!message}
      onClose={() => setMessage(null)}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle
        style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#d32f2f' }}
      >
        <ErrorOutlineIcon />
        เกิดข้อผิดพลาด
      </DialogTitle>
      <DialogContent>
        <DialogContentText style={{ whiteSpace: 'pre-wrap' }}>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setMessage(null)} variant="contained">
          ตกลง
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GlobalErrorDialog;
